/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Support_Form_SentInputs */

const en_support_form_sent = /** @type {(inputs: Support_Form_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message sent — thank you! We will get back to you by email.`)
};

const id_support_form_sent = /** @type {(inputs: Support_Form_SentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan terkirim — terima kasih! Kami akan balas lewat email.`)
};

/**
* | output |
* | --- |
* | "Message sent — thank you! We will get back to you by email." |
*
* @param {Support_Form_SentInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const support_form_sent = /** @type {((inputs?: Support_Form_SentInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Support_Form_SentInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_support_form_sent(inputs)
	return en_support_form_sent(inputs)
});